import styled from "styled-components";

const Footer = styled.div`
  text-align: right;

  & > button:first-child {
    margin-right: 0.5rem;
  }
`;

export default Footer;
